import React from 'react';
import styled from 'styled-components';
import { colours, fontSize, spacing, breakpoints } from '../../../theme';

import { ReactComponent as Exit } from '../../../assets/exit-black.svg';

const StyledModal = styled.div`
  z-index: 20;
  width: 50%;
  position: fixed;
  top: 20%
  left: 25%;
  right: 25%;
  border: solid 0.3em ${colours.yellow};
  background-color: ${colours.white};
  font-size: ${fontSize.tiny};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${spacing.tiny};
  
  @media (min-width: ${breakpoints.desktop}) {
    font-size: ${fontSize.small};
  }
`;

const CrossContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
const Cross = styled(Exit)`
  cursor: pointer;
`;

const ModalHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const SchemeLogo = styled.img`
  max-width: 6em;
  max-height: 6em;
  object-fit: contain;
`;

const SchemeTitle = styled.h3`
  font-size: ${fontSize.tiny};
`;

const SchemeDescription = styled.p`
  text-align: center;
`;

const SchemeLink = styled.a`
  color: ${colours.black};
  text-decoration: underline;
  :hover {
    background-color: ${colours.yellow};
  }
`;


const Modal = ({ schemesRecord, setModalIsOpen, criteriaName }) => {

  const closeModalWithCross = () => {
    setModalIsOpen(false);
  }

  const spaceForUnderscore = (scheme_name) => {
    const nameWithUnderscore = scheme_name;
    const characters = nameWithUnderscore.split("");
    return (characters.map(x => {
      return (x === "_") ? " " : x;
    })).join("");
  }

  const displayClickedCriteria = (schemeRecord) => {
    if (schemeRecord.fields.scheme_name === criteriaName) {
      return (
        <div>
          <CrossContainer>
            <Cross
              onClick={closeModalWithCross}
            />
          </CrossContainer>
          <ModalHeader>
            <SchemeLogo src={schemeRecord.fields.scheme_logo_url} />
            <SchemeTitle>{spaceForUnderscore(schemeRecord.fields.scheme_name)}</SchemeTitle>
          </ModalHeader>
          <SchemeDescription>{schemeRecord.fields.scheme_description}</SchemeDescription>
          <SchemeLink
            href={schemeRecord.fields.scheme_website}
            title={schemeRecord.fields.scheme_name}
            target="_blank"
            rel="noopener noreferrer"
          >
            More information
        </SchemeLink>
        </div>
      );
    }
  };

  return (
    <div>
      <StyledModal>
        {schemesRecord.map(schemeRecord => displayClickedCriteria(schemeRecord))}
      </StyledModal>
    </div>
  );
};

export default Modal;
